import { atom } from "recoil";

export const pdfViewerFullScreenState = atom<boolean>({
  key: "PdfViewerFullScreenState",
  default: false,
});
